import React, { useEffect, useState } from "react";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { addParamToUrl } from "../Sidebar/FilterUrlHelpers";
import Icon from "~/common/Icons/Critical";
const OutletSearch = () => {
  const [currentUrl, setCurrentUrl] = useState("");
  const [formSubmitUrl, setFormSubmitUrl] = useState("");
  const [searchString, setSearchString] = useState("");
  useEffect(() => {
    setCurrentUrl(window.location.pathname + window.location.search);
    setFormSubmitUrl(window.location.pathname);
  }, []);
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = String(event.target.value);
    setSearchString(searchText);
  };
  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    const searchText = searchString.trim();
    if (searchText.length > 0) {
      const updatedUrl = addParamToUrl(currentUrl, "withinval", searchText);
      setWindowLocationHref(updatedUrl);
    }
  };
  return <div data-component="outlet-search" data-testid="outlet-search" className="mt-16 text-center clear-both" data-sentry-component="OutletSearch" data-sentry-source-file="OutletShopAllProducts.tsx">
      <p className="text-3xl font-semibold mb-4">Shop All Outlet Products</p>
      <form id="outletShopAllProductsForm" className="shadow md:w-3/4 max-w-xl my-0 mx-auto flex flex-row h-12 rounded" action={formSubmitUrl} method="get" onSubmit={handleSubmit}>
        <input id="outletShopAllProductsSearchWithin" data-testid="outletShopAllProductsSearchWithin" type="text" className="box-border pl-4 bg-white border border-solid border-gray-500 border-r-0 h-12 rounded w-full rounded-r-none focus:border-blue-400" aria-label="Search Outlet: type a search term and hit enter" value={searchString} onChange={handleSearchChange} />
        <button type="submit" className="btn btn-info h-12 rounded-l-none px-4" value="Search">
          <span className="sr-only">Search</span>
          <Icon className="fill-current h-6 text-white w-4" height="1rem" width="1rem" name="search" aria-hidden="true" data-sentry-element="Icon" data-sentry-source-file="OutletShopAllProducts.tsx" />
        </button>
      </form>
    </div>;
};
export default OutletSearch;